module.exports = __webpack_public_path__ + "img/hi-lo.71b6f91.webp";